import { DownloadAppLinkPlatform } from '../types/download-app-link.type';

export const DOWNLOAD_APP_BADGES: Record<DownloadAppLinkPlatform, string> = {
  AppStore: 'assets/images/badge_app_store.svg',
  GooglePlay: 'assets/images/badge_google_play.svg',
};
